import React from 'react'
import { FormattedMessage } from 'react-intl'
import { isString } from 'lodash'
import { NotifyWrapper } from './styled'

export const NotificationComponent = (props) => {
	const { kind, message } = props

	const messagePrefix = kind === 'danger' ? 'errors' : 'labels'

	const { id, values } = isString(message)
		? { id: `${messagePrefix}.${message}`, values: {} }
		: { id: `${messagePrefix}.${message.template}`, values: message.params }

	return (
		<NotifyWrapper kind={kind}>
			<div>
				<FormattedMessage id={id} defaultMessage={id} values={values} />
			</div>
		</NotifyWrapper>
	)
}
